import CustomButton from "./CustomButton";
import addIcon from "../assets/add_icon.png";
import { useTranslation } from "react-i18next";
import useLanguage from "../utils/useLanguage";

export const GENDER = Object.freeze({
  MALE: "male",
  FEMALE: "female",
});

export default function AddAnotherButton({
  variant,
  arrayLength,
  title,
  gender,
  ...props
}) {
  const { t } = useTranslation("general");
  const { currentDirection } = useLanguage();

  let btnTitle = title;

  if (arrayLength > 0 && currentDirection === "rtl" && gender) {
    btnTitle = `${title} ${
      gender === GENDER.MALE ? t("maleAnother") : t("femaleAnother")
    }`;
  }

  return (
    <CustomButton
      variant={variant || "blank"}
      icon={addIcon}
      iconSize={16}
      {...props}
      title={btnTitle}
    />
  );
}
